
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { RetentionService } from 'src/app/_services/retention.service';
import { PolicyService } from 'src/app/_services/policy.service';
import { IRetentionGroup } from 'src/app/_models/compliance';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { CategoryService } from 'src/app/_services/category.service';
import { RuleModel, ColumnsModel, TemplateColumn, QueryBuilder } from '@syncfusion/ej2-angular-querybuilder';
import { Browser } from '@syncfusion/ej2-base';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'src/assets/config/config/app-config';
import { environment } from '@environments/environment';



@Component({
  selector: 'app-retention',
  templateUrl: './retention.component.html',
  styleUrls: ['./retention.component.scss'],
  providers: [DatePipe]

})

export class RetentionComponent implements OnInit {
  category = new FormControl();
  categories: any[]
  fetchedId: number;
  name: string;
  allRetentionDate = ["Create Date", "Active Version Date"]
  isEqual: boolean = false;
  fetchedName: string;
  description: string = "";
  fetchedDescription: string;
  disposalPolicyId: string;
  archivalPolicyId: string;
  fetchedDisposalPolicyId: string;
  fetchedArchivalPolicyId: string;
  fetchedRetentionDate: string;
  fetchedCriteria: string;
  disposalPolicyIdInteger: number;
  archivalPolicyIdInteger: number;
  retentionDate: string;
  criteriaQuery: any;
  criteriaJSON: any;
  allCategoryProperties = []
  isDisplayRetention: Boolean;
  isCreateRetention: Boolean = false;
  isUpdateRetention: Boolean = false;
  allPolicies = []
  allCategories = []
  createFormData: FormGroup
  reApplyForm: FormGroup
  retentionGroupId: number;
  fetchedCategories: any;
  query: any = "";
  selectedCategoryId: any[];
  allRetentionDateValues = ["Create Date", "Active Version Date"]
  retentionGroupValues: []
  allRetentionGroup: MatTableDataSource<IRetentionGroup>
  displayedColumns: any[]
  searchCtrl: string = "";
  retentionCreated: boolean = false;
  retentionUpdated: boolean = false;
  retentionApplied: boolean = false;
  noRetentionGroups: boolean = false;
  retentionGroupsCount: number;
  isFixed: boolean = false;
  toArchive: boolean = false;
  fetchedArchive: boolean = false;
  archive: boolean;

  public showButtons: Object = { groupInsert: false, groupDelete: true, ruleDelete: true }



  public data: Object[];
  public importRules: RuleModel;
  @ViewChild('querybuilder')
  qryBldrObj: QueryBuilder = new QueryBuilder({
    allowValidation: true
  });

  id: number
  constructor(private retentionService: RetentionService,
    private fb: FormBuilder,
    private policyService: PolicyService,
    private categoryService: CategoryService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private config: AppConfig
  ) {

    this.createFormData = this.fb.group({
      name: ['', Validators.required],
      disposal_policy_id: ['', Validators.required],
      archival_policy_id: [''],
      description: ['', Validators.required],
      categories: ['', Validators.required],
      criteria: ['', Validators.required],
      retentiondate: ['', Validators.required],
      archive: ['']
    })

    this.reApplyForm = this.fb.group({
      reApply: ['']
    })
  }

  sort
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.allRetentionGroup.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.allRetentionGroup.paginator = this.paginator;
    }
  }

  public filter: ColumnsModel[];
  public paymentTemplate: TemplateColumn;
  public inOperators: string[] = ['in', 'notin'];

  ngOnInit(): void {
    this.isDisplayRetention = true;
    this.archive = this.config.getConfig("archive");
    if (this.archive) {
      this.displayedColumns = ["name", "disposal_policy_id", "archival_policy_id", "datecreated", "created_by", "reApply", "actions"];
    } else {
      this.displayedColumns = ["name", "disposal_policy_id", "datecreated", "created_by", "reApply", "actions"];
    }
    this.policyService.getPolicy().subscribe(policies => {
      this.allPolicies = policies;
      // for (let i in this.allPolicies) {
      //   this.allPolicyId.push(this.allPolicies[i].id)
      //   //print()
      // }
    })

    this.categoryService.getAll().subscribe(resp => {
      this.allCategories = resp['results']
    })

    this.retentionService.getRetention().subscribe(retentionGroup => {
      if (retentionGroup == "") {
        this.noRetentionGroups = true
        this.allRetentionGroup = null
      } else {
        this.retentionGroupValues = retentionGroup;
        this.allRetentionGroup = new MatTableDataSource(retentionGroup);
        this.allRetentionGroup.sort = this.sort;
        this.allRetentionGroup.paginator = this.paginator;
        this.noRetentionGroups = false
        this.retentionGroupsCount = retentionGroup.length
        this.allRetentionGroup.sortingDataAccessor = (item, property) => {
          switch (property) {
            case 'datecreated': return new Date(item.create_date);
            default: return item[property];
          }
        };
      }
    });



    this.qryBldrObj.appendTo('#querybuilder');

    this.filter = []
    for (let property of this.allCategoryProperties) {
      var newProp = "'" + property + "'"
      this.filter.push({
        field: newProp, label: property, type: "string", validation: { isRequired: true }
      })
    }

    this.importRules = {
      'label': 'Property',
      'field': 'Property',
      'type': 'string',
      'operator': 'equal',
      'value': ''

    };

  }

  checkPolicyType(policyId) {
    //console.log(policyId)
    this.allPolicies.find(x => {
      x.id == policyId; if (x.id == policyId) {
        console.log("Policy", x)
        if (x.type == "Fixed") {
          this.isFixed = true
        }
        else {
          this.isFixed = false
        }
      }
    })
  }

  getDisplayListData(searchFormCategories) {
    this.allRetentionDateValues = ["Create Date", "Active Version Date"]
    this.allRetentionDate = ["Create Date", "Active Version Date"]
    this.isEqual = false;
    this.allCategoryProperties = []
    for (let category of this.allCategories) {
      for (let selectedCategory of searchFormCategories) {
        if (category.id == selectedCategory) {

          for (let metaData of category.meta_data_definition) {
            if (metaData.active) {
              for (let property of metaData.properties) {
                this.allCategoryProperties.push(property.name)
                //console.log("ALL PROP", this.allCategoryProperties)
                if (property.data_type === "date") {
                  this.allRetentionDateValues.push(property.name)
                }
              }
            }
          }
        }
      }
    }

    this.allRetentionDateValues.forEach(element => {
      var occurrences = this.allRetentionDateValues.filter(function (val) {
        return val === element;
      }).length;
      if (occurrences == searchFormCategories.length) {
        this.allRetentionDate.push(element)

      }

    });

    this.allRetentionDate = this.allRetentionDate.filter((elem, i, arr) => {
      if (arr.indexOf(elem) === i) {
        return elem
      }

    })

    this.allCategoryProperties = this.allCategoryProperties.filter((elem, i, arr) => {
      if (arr.indexOf(elem) === i) {
        return elem
      }
    })

    this.filter = []
    for (let property of this.allCategoryProperties) {
      //console.log("PROPERTY", property)
      var newProp = "'" + property + "'"
      this.filter.push({
        field: newProp, label: property, type: "string", validation: { isRequired: true }
      })
    }
    this.importRules = {
      'label': 'Property',
      'field': 'Property',
      'type': 'string',
      'operator': 'equal',
      'value': ''

    };

  }



  importRule: RuleModel = {
    'condition': 'and',
    'rules': [
      {
        'label': 'Property',
        'field': "Property",
        'type': 'string',
        'operator': 'equal',
        'value': 'Sales Manager'
      }]
  };

  createdControl(): void {
    if (Browser.isDevice) {
      this.qryBldrObj.summaryView = true;
    }

    this.criteriaQuery = this.qryBldrObj.getPredicate(this.qryBldrObj.rule)

    //console.log("THIS IS THE QUERY", this.criteriaQuery)
  }



  queryBuilder() {
    this.qryBldrObj.validateFields();
    this.criteriaQuery = this.qryBldrObj.getSqlFromRules(this.qryBldrObj.getRules())
    var meta_data = "meta_data->'properties'->>"
    var temp = []
    var criteria = ""
    var my_str = this.criteriaQuery
    var regexUnderscore = new RegExp("/AND/g"); //indicates global match
    var regexHash = new RegExp("/OR/ ", "g");

    // criteria = this.criteriaQuery.replace(regexHash, regexHash+meta_data).replace(regexUnderscore, regexUnderscore+meta_data);
    // // var substrAND = "AND "
    // var susbstrOR = "OR "
    // criteria = meta_data + this.criteriaQuery.replace("AND", "ANDjhsdsfius")

    // criteria = meta_data + this.criteriaQuery.replace("OR", "OR"+meta_data)
    if (this.criteriaQuery.includes("AND")) {
      this.criteriaQuery = meta_data + this.criteriaQuery.split("AND").join("AND " + meta_data)

    }
    else if (this.criteriaQuery.includes("OR")) {
      this.criteriaQuery = meta_data + this.criteriaQuery.split("OR").join("OR " + meta_data)

    }
    else {
      this.criteriaQuery = meta_data + this.criteriaQuery
    }

    this.query = this.criteriaQuery

  }

  dataBound() {
    const id = 'id';
    const rowIndexes: number[] = [];
    (this.qryBldrObj.dataSource as object[]).forEach((sdata, index) => {
    });

  }

  refreshTable() {
    this.criteriaQuery = this.qryBldrObj.getSqlFromRules(this.qryBldrObj.getRules())
    this.criteriaJSON = this.qryBldrObj.rule.rules
    for (let i in this.criteriaJSON) {
      if (this.criteriaJSON[i].label === "Category ID") {
      }

    }
  }
  applyRetention(event, retention, data) {
    if (data.reApply == "" || data.reApply == null) {
      data.reApply = false
    }
    var applyRetentionReq = {
      retentiongroupid: parseInt(retention.id),
      reapply: data.reApply
    }
    this.retentionService.applyRetention(applyRetentionReq).subscribe(obj => {
      this.fetchedName = retention.name
      this.retentionApplied = true;
      this.reApplyForm.reset()
    })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.allRetentionGroup.filter = filterValue.trim().toLowerCase();
    if (this.allRetentionGroup.paginator) {
      this.allRetentionGroup.paginator.firstPage();
    }
  }

  saveCreateRetention() {
    this.fetchedName = this.name
    this.disposalPolicyIdInteger = Number(this.disposalPolicyId);
    var createRetentionPayload = {
      name: this.name,
      description: this.description,
      disposal_policy_id: this.disposalPolicyIdInteger,
      document_search_str: {
        "categories": this.categories,
        "criteria": this.query
      }
    }

    if (this.toArchive) {
      this.archivalPolicyIdInteger = Number(this.archivalPolicyId);
      createRetentionPayload["archival_policy_id"] = this.archivalPolicyIdInteger;
    }

    if (!this.isFixed) {
      createRetentionPayload.document_search_str["retention_date"] = this.retentionDate;
    }
    //console.log(createRetentionPayload);
    this.retentionService.createRetentionGroup(createRetentionPayload).subscribe(resp => {
      this.retentionCreated = true
      this.retentionGroupId = resp, this.retentionService.getRetention().subscribe(retentionGroup => {
        this.retentionGroupValues = retentionGroup;
        this.allRetentionGroup = new MatTableDataSource(retentionGroup);
        this.allRetentionGroup.sort = this.sort;
        this.allRetentionGroup.paginator = this.paginator;
      });
      this.name = null;
      this.disposalPolicyId = null;
      this.archivalPolicyId = null;
      this.query = null;
      this.retentionDate = null;
      this.categories = null;
      this.description = null;
    }) //,error =>
    //alert("Error Message: " + error.error[0]))
  }



  displayPage() {
    //this.ngOnInit()
    this.retentionUpdated = false;
    this.retentionCreated = false;
    this.retentionApplied = false;
    this.isCreateRetention = false;
    this.isDisplayRetention = true;
    this.isUpdateRetention = false;

  }

  createRetentionGroup(event) {
    this.isCreateRetention = true
    this.isDisplayRetention = false
    this.isUpdateRetention = false
    this.selectedCategoryId = []
    //alert(`Adding hold for application ${this.appId}...`)
  }


  saveUpdateRetention() {

    this.disposalPolicyIdInteger = Number(this.fetchedDisposalPolicyId);
    var updateRetentionPayload = {
      Id: this.fetchedId,
      name: this.fetchedName,
      description: this.fetchedDescription,
      disposal_policy_id: this.disposalPolicyIdInteger,
      document_search_str: {
        "categories": this.fetchedCategories,
        "criteria": this.fetchedCriteria
      }
    }

    if (this.fetchedArchive) {
      updateRetentionPayload["archival_policy_id"] = this.fetchedArchivalPolicyId;
    }

    if (!this.isFixed) {
      updateRetentionPayload.document_search_str["retention_date"] = this.fetchedRetentionDate;
    }

    this.retentionService.updateRetentionGroup(updateRetentionPayload).subscribe(resp => {
      this.retentionUpdated = true
      this.retentionGroupId = resp, this.retentionService.getRetention().subscribe(retentionGroup => {
        this.retentionGroupValues = retentionGroup;
        // retentionGroup.forEach(retGroup => console.log("retgrp", retGroup.policyid)
        // );
        this.allRetentionGroup = new MatTableDataSource(retentionGroup);
        this.allRetentionGroup.sort = this.sort;
        this.allRetentionGroup.paginator = this.paginator;
      });
      //error=>
      //alert("Error Message: " + error.error[0]))
    })

  }

  updateRetention(event, retention) {
    this.isCreateRetention = false
    this.isDisplayRetention = false
    this.isUpdateRetention = true
    this.fetchedId = retention.id
    this.fetchedName = retention.name
    this.fetchedDisposalPolicyId = retention.disposal_policy_id
    if (retention.archival_policy_id != null) {
      this.fetchedArchive = true;
      this.fetchedArchivalPolicyId = retention.archival_policy_id
    } else {
      this.fetchedArchive = false;
      this.fetchedArchivalPolicyId = null;
    }
    this.fetchedDescription = retention.description
    this.fetchedRetentionDate = retention.document_search_str.retention_date
    this.fetchedCategories = retention.document_search_str.categories
    this.fetchedCriteria = retention.document_search_str.criteria
    this.getDisplayListData(this.fetchedCategories)
    this.checkPolicyType(this.fetchedDisposalPolicyId)
  }

  deletePolicy($event, id: number) {
    id
  }

  back() {
    this.retentionUpdated = false;
    this.retentionCreated = false;
    this.retentionApplied = false;
  }
}